module.exports = __webpack_public_path__ + "img/lunbotu3.d4c57210.png";